module.exports = __webpack_public_path__ + "static/media/seriousCall.f88a00fc.mp3";